import Swiper, {Navigation, Lazy, Keyboard, A11y, EffectCoverflow, Autoplay} from 'swiper';

Swiper.use([Navigation, Lazy, Keyboard, A11y, EffectCoverflow, Autoplay]);

const initUpcomingEventsSliders = () => {
    function initializeSwiper(gallery) {
        let auto = gallery.getAttribute('data-autoplay');
        let swiperContainer = gallery.querySelector('.swiper-container');
        let prevSlide = gallery.querySelector('.swiper-button-prev');
        let nextSlide = gallery.querySelector('.swiper-button-next');
        let thresholdValue = 0.5;

        if (swiperContainer.closest('.ume-tabs')) {
            thresholdValue = 0;
        }

        let newSlider = new Swiper(swiperContainer, {
            direction: 'horizontal',
            grabCursor: 'true',
            speed: 600,
            slidesPerView: 1,
            spaceBetween: 16,
            autoplay: auto === 'autoplay' ? {
                delay: swiperContainer.getAttribute('data-delay'),
                disableOnInteraction: true,
            } : false,
            breakpoints: {
                1268: {
                    slidesPerView: 3,
                    spaceBetween: 0,
                },
                780: {
                    slidesPerView: 2,
                    spaceBetween: 16,
                },
            },
            keyboard: {
                enabled: true,
                onlyInViewport: false,
            },
            a11y: {
                prevSlideMessage: 'Zurück',
                nextSlideMessage: 'Weiter'
            },
            centeredSlides: false,
            navigation: {
                nextEl: nextSlide,
                prevEl: prevSlide,
            },
        });
    }

    function handleIntersection(entries, observer) {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                initializeSwiper(entry.target);
                observer.unobserve(entry.target);
            }
        });
    }

    let options = {
        rootMargin: '400px'
    };

    let observer = new IntersectionObserver(handleIntersection, options);

    document.querySelectorAll('.ume-upcoming-events-slider').forEach(gallery => {
        observer.observe(gallery);
    });
}

initUpcomingEventsSliders();